import { GeoJsonLayer } from '@deck.gl/layers/typed';
import { Feature } from '@turf/helpers';
import { useMemo } from 'react';
import { useMapTooltipContext } from '../../contexts/MapTooltipProvider';

export const useExtrudedGeoJsonLayer = ({ geoJson }: { geoJson: Feature[] }) => {
  const { onHover } = useMapTooltipContext();
  const extrudedGeoJsonLayer = useMemo(
    () =>
      new GeoJsonLayer({
        id: 'extrudedGeojson',
        data: geoJson,
        pickable: false,
        getLineColor: (feature) => feature.properties?.lineColor ?? 'black',
        onHover,
        getElevation: (d) => d?.properties?.elevation ?? 0,
        extruded: true,
        filled: false,
        stroked: true,
        wireframe: true,
        lineWidthScale: 1,
        lineWidthUnits: 'meters',
        order: 2,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [geoJson]
  );

  return { extrudedGeoJsonLayer };
};
